export const APP_STORE_URL =
  "https://apps.apple.com/us/app/careem-rides-food-delivery/id592978487";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.careem.acma&hl=en&gl=US";
export const CAREEM_APP_URL = "careem://open";
export const ANALYTICKA_EVENT_NO_INVOICE_ID = "no_invoice_id_provided";
export const HELP_CENTER_LINK = {
  CODE_VERIFICATION:
    "https://help.careem.com/hc/en-us/articles/360001609587-What-if-I-didn-t-receive-a-verification-code-",
  CREATE_ACCOUNT:
    "https://help.careem.com/hc/en-us/articles/360001609507-Creating-an-account",
  FORGET_PASSWORD:
    "https://help.careem.com/hc/en-us/articles/360001592468-I-forgot-my-password",
};

export const BLOCKED_LINK = "https://help.careem.com/hc/en-us/requests/new";



export const ANALYTIKA_EVENTS = {
  PAGE: {
    BLOCKED_USER: "blocked_user",
    WELCOME_BACK_IS_IT_YOU: "welcome_back_isityou",
    PASSWORD: "password",
    WELCOME: "welcome",
    OTP_VERIFY: "otp_verify",
    BUSINESS_INVITATION: "business_invitation",
    BUSINESS_INVITATION_SWITCH_ACCOUNT: "business_invitation_switch_account",
    BUSINESS_INVITATION_ERROR: "business_invitation_error",
    FORGOT_PASSWORD: "forgot_password",
    SIGNUP_FORM: "signup_form",
    VERIFY__CARD_FORM_VIEW: "verify__card_challenge",
    VERIFY_EMAIL_FORM_VIEW: "verify_email_challenge",
    VERIFY_FULL_NAME_FORM_VIEW: "verify_full_name_challenge",
    VERIFY_PIN_FORM_VIEW: "verify_pin_challenge",
    NEW_PASSWORD: "new_password", //nosonar
    INSTANT_CREDENTIALS_FORM: "instant_credentials_form",
    MERCHANT_SIGNUP_FORM: "merchant_signup_form",
    DASHBOARD_SELECTION: "dashboard_selection",
    CORPORATE_USER_ENROLMENT: "corporate_user_enrolment",
    CORPORATE_EMAIL_VERIFICATION: "corporate_email_verification",
    UNLINK_EMAIL: "unlink_email",
    VERIFICATION_LINK_EXPIRED: "verification_link_expired",
    EMAIL_VERIFIED: "email_verified",
    VERIFICATION_TOKEN_ALREADY_USED: "verification_token_already_used",
    APPLE_LOGIN_FORM: "apple_form",
    GOOGLE_LOGIN_FORM: "google_form",
    EMAIL_LOGIN_FORM: "email_form",
    EMAIL_VERIFICATION: "email_verification",
  },
  FLOW: {
    INSTANT_CREDENTIALS: "instant_credentials",
    APPLE: "apple",
    GOOGLE: "google",
    EMAIL: "email",
    PHONE: "phone",
    BIOMETRIC: "biometric",
    GUEST: "guest",
    ONE_CLICK: "one_click",
  },
  IDNW_ENTER_PHONE_NUMBER: {
    event_name: "idnw_enter_phone_number",
    event_version: 19,
    signature: "ARMCDiB8AAAAAAAAAIeBCNqDJR0U0yHun98vNuQ_AAAAAAAAAFI",
  },
  IDNW_TAP_BUTTON: {
    event_name: "idnw_tap_button",
    event_version: 20,
    signature: "ARQCEiB8AAAAAAAAAK1jry1Wq_UMosLXWWhLQw5fAAAb80WFmLs",
  },
  IDNW_TAP_OPTION: {
    event_name: "idnw_tap_option",
    event_version: 20,
    signature: "ARQCESB8AAAAAAAAAKP-XciZGTSTfWAZyBd7OrfWAAAABUjfY-M",
  },
  IDNW_SELECT_LANGUAGE: {
    event_name: "idnw_select_language",
    event_version: 12,
    signature: "AQwBESB8AAAAAAAAAKPC2OwJC72HWuBQ4DUHoLP_AAAABWbzXug",
  },
  IDNW_SELECT_COUNTRY: {
    event_name: "idnw_select_country",
    event_version: 16,
    signature: "ARACDiB8AAAAAAAAAIeDSPyHZR3V2yVsnZcnNsA9AAAAAAAAAFI",
  },
  IDNW_VIEW_PAGE: {
    event_name: "idnw_view_page",
    event_version: 24,
    signature: "ARgBDyB8AAAAAAAAAJDw-LAHDqGgC-f53ArXtpwpAAAAAAAAJSA",
  },
  IDNW_ENTER_PASSWORD: {
    event_name: "idnw_enter_password",
    event_version: 18,
    signature: "ARICDyB8AAAAAAAAAJDwupAXLqmgK-O6WArHtpwrAAAAAAAAJyA",
  },
  IDNW_SEND_WEBREQUEST: {
    event_name: "idnw_send_webrequest",
    event_version: 22,
    signature: "ARYCESB8AAAAAAAAAKPeWciZFTSTeXAZ6Fd7MLbWAAAAB1jfY-E",
  },
  IDNW_SUCCESS_LOGIN: {
    event_name: "idnw_success_login",
    event_version: 26,
    signature: "ARoCEyB8AAAAAAAAALcp4dAs70e7NN8qNrp_1qRhAFmBS7ve-BA",
  },
  IDNW_ENTER_OTP: {
    event_name: "idnw_enter_otp",
    event_version: 25,
    signature: "ARkCEiB8AAAAAAAAAK1jJT0Wq_0MqsLDWWhLRw57AAAbI0WVmLs",
  },
  IDNW_ENTER_NAME: {
    event_name: "idnw_enter_name",
    event_version: 19,
    signature: "ARMCDyB8AAAAAAAAAJD2uJJXLqHgK-O6WArH9rwjAAAAAAAANWA",
  },
  IDNW_SUCCESS_SIGNUP: {
    event_name: "idnw_success_signup",
    event_version: 24,
    signature: "ARgCECB8AAAAAAAAAJpms6SodVCrokpVe20j8LqqAAAAAAO1AYI",
  },
  IDNW_SEND_WEBRESPOSE: {
    event_name: "idnw_receive_webresponse",
    event_version: 22,
    signature: "ARYCFCB8AAAAAAAAAMD8v6OlF1haQs8Q0Eu_NuihVJZqoeEQgoM",
  },
  IDNW_VIEW_ERROR: {
    event_name: "idnw_view_error",
    event_version: 21,
    signature: "ARUCESB8AAAAAAAAAKPemdCZEbTT2WE5wTc7ELb1AAAABUj7I-I",
  },
  PYCK_VIEW_CK_PAGE: {
    event_name: "pyck_view_ck_page",
    event_version: 1,
    signature: "",
  },
  PYCK_TAP_PAGE: {
    event_name: "pyck_tap_page",
    event_version: 1,
    signature: "",
  },
  PYCK_TAP_CK_BUTTON: {
    event_name: "pyck_tap_ck_button",
    event_version: 1,
    signature: "",
  },
  PYCK_RESPONSE_CK_BUTTON: {
    event_name: "pyck_response_ck_button",
    event_version: 1,
    signature: "",
  },
  PYCK_RESPONSE_PHONE_SUBMIT: {
    event_name: "pyck_response_phone_submit",
    event_version: 1,
    signature: "",
  },
  PYCK_RESPONSE_CK_VALIDATION: {
    event_name: "pyck_response_ck_validation",
    event_version: 1,
    signature: "",
  },
};
